// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserCircle, faCalendarAlt, faExternalLinkSquareAlt,
  faMoneyCheckAlt, faCircleNotch, faCheckCircle, faTimesCircle,
  faPlus, faPencilAlt, faTrashAlt, faChevronCircleDown, faChevronCircleUp,
  faChevronCircleRight, faMoneyBillWave, faProjectDiagram, faShippingFast,
  faLevelUpAlt, faLock, faUnlock, faCheck, faSlidersH, faUndo, faComment,
  faUserSlash, faArrowLeft, faTimes, faPlusCircle, faStoreAlt, faInfoCircle,
  faCartPlus, faShoppingCart, faChevronCircleLeft, faCircle, faCreditCard } from '@fortawesome/free-solid-svg-icons'
import { faCircle as farCircle } from '@fortawesome/free-regular-svg-icons'
import { faKickstarter, faPaypal, faCcPaypal, faFacebook } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import App from './App'
import { router } from './router'
import i18n from './i18n'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import store from './vuex'
import axios from 'axios'
import VueStringFilter from 'vue-string-filter'
import jQuery from 'jquery'
import CKEditor from '@ckeditor/ckeditor5-vue'
import '@ckeditor/ckeditor5-build-classic/build/translations/nl.js'
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
import VueCookies from 'vue-cookies'
import Loading from 'vue-loading-overlay'
import FlagIcon from 'vue-flag-icon'
import ClickConfirm from './components/ClickConfirm'
import Nl2br from 'vue-nl2br'

import { userService } from './services/user.service'
import { tokenService } from './services/token.service'

import 'vue-loading-overlay/dist/vue-loading.css'

function getCookie (name) {
  // Split cookie string and get all individual name=value pairs in an array
  var cookieArr = document.cookie.split(';')

  // Loop through the array elements
  for (var i = 0; i < cookieArr.length; i++) {
    var cookiePair = cookieArr[i].split('=')

    /* Removing whitespace at the beginning of the cookie name
    and compare it with the given string */
    if (name === cookiePair[0].trim()) {
      // Decode the cookie value and return
      return decodeURIComponent(cookiePair[1])
    }
  }

  // Return null if not found
  return null
}

Vue.use(BootstrapVue)
Vue.use(VueCookies)
Vue.use(VueStringFilter)
Vue.use(CKEditor)
Vue.component('nl2br', Nl2br)
Vue.component('clickConfirm', ClickConfirm)
Vue.component('vue-bootstrap-typeahead', VueBootstrapTypeahead)
Vue.use(FlagIcon)
Vue.use(Loading, {
  container: null,
  canCancel: false,
  color: '#DF815B'
})

library.add(faUserCircle, faCalendarAlt, faExternalLinkSquareAlt, faMoneyCheckAlt, faCircleNotch,
  faCheckCircle, faTimesCircle, faPlus, faPencilAlt, faTrashAlt, faChevronCircleDown, faChevronCircleUp,
  faChevronCircleRight, faMoneyBillWave, faProjectDiagram, faShippingFast, faLevelUpAlt, faLock, faUnlock,
  faCheck, faSlidersH, faUndo, faUserSlash, faArrowLeft, faTimes, faPlusCircle, faStoreAlt, faInfoCircle,
  faCartPlus, faShoppingCart, faChevronCircleLeft, faCircle, farCircle, faComment, faKickstarter, faPaypal,
  faCcPaypal, faFacebook, faCreditCard)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.prototype.$http = axios

Vue.config.productionTip = false
Vue.prototype.$hostname = (process.env.NODE_ENV === 'production') ? 'https://www.crowdfinder.be' : 'https://www.crowdfinder.be'

Vue.filter('round', function (value, decimals) {
  if (value === undefined || value.length === 0 || isNaN(parseFloat(value))) {
    return value
  }

  if (!decimals) {
    decimals = 0
  }

  let returnValue = parseFloat(value)
  // bugfix for values under 0.01 getting NaN!
  if ((returnValue < 0.01 && returnValue > 0) || (returnValue > -0.01 && returnValue < 0)) {
    returnValue = 0
  }
  return ((Math.round(returnValue + 'e' + decimals) + 'e-' + decimals) / 1).toFixed(decimals)
})

axios.interceptors.request.use((config) => {
  if (config.url.includes(Vue.prototype.$hostname)) {
    const token = store.state.accessToken
    if (token) {
      config.headers.Authorization = 'Bearer ' + token
    }
  }
  return config
}, (error) => {
  return new Promise((resolve, reject) => {
    reject(error)
  })
})

axios.interceptors.response.use((response) => {
  let accessToken = response.data.accessToken
  if (accessToken) {
    store.commit('accessToken', accessToken)
  }
  let refreshToken = response.data.refreshToken
  if (refreshToken) {
    store.commit('refreshToken', refreshToken)
  }
  return response
}, (error) => {
  return new Promise((resolve, reject) => {
    if (error.response.status === 401) {
      const originalRequest = error.config
      if (!originalRequest.url.includes('refresh-token')) {
        store.commit('swapRefreshToAccessToken')

        // now execute new request to get new token
        tokenService.refresh().then((response) => {
          originalRequest._refresh = true
          resolve(axios(originalRequest))
        }, () => {
          if (getCookie('cf_remember_me')) {
            store.commit('keepLoginBar', true)
          }
          userService.logout()
          location.reload(true)
          resolve()
        })
      } else {
        if (getCookie('cf_remember_me')) {
          store.commit('keepLoginBar', true)
        }
        userService.logout()
        location.reload(true)
        resolve()
      }
    } else {
      reject(error)
    }
  })
})

jQuery.extend(true, jQuery.fn.datetimepicker.defaults, {
  icons: {
    time: 'far fa-clock',
    date: 'far fa-calendar',
    up: 'fas fa-arrow-up',
    down: 'fas fa-arrow-down',
    previous: 'fas fa-chevron-left',
    next: 'fas fa-chevron-right',
    today: 'fas fa-calendar-check',
    clear: 'far fa-trash-alt',
    close: 'far fa-times-circle'
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App, VueBootstrapTypeahead },
  template: '<app />',
  store: store
})



// WEBPACK FOOTER //
// ./src/main.js